export const faqItems = [
  {
    question: "How do I book a car?",
    answer:
      "Once you send us an enquiry through phone, website or email our friendly staff will get back to you with availability and pricing. To confirm your booking, we require a minimum $100.00 non-refundable deposit credited to your rental. Payments can be made via bank card, bank transfer, PAY ID or cash.",
  },
  {
    question: "How old do I need to be to rent a car?",
    answer:
      "We allow all drivers over the age of 21. Probationary license holders may incur additional rental charges. All drivers require a valid driver's license.",
  },
  {
    question: "What documents do I need to rent a car?",
    answer:
      "You will need a driver's license, bank card (credit or debit), and secondary proof of address such as a utility bill or lease agreement.",
  },
  {
    question: "Are there any hidden charges or fees?",
    answer:
      "We are a transparent company with no hidden fees. All fees are outlined on our rental agreement. For traffic fines and tolls we charge a $33 nomination fee. Smoking in cars may incur cleaning fees of minimum $150.00.",
  },
  {
    question: "Can I add an additional driver?",
    answer: "One additional driver can be added at no extra cost.",
  },
  {
    question: "What happens if I return the car late?",
    answer:
      "We allow after hours drop off when arranged with our staff. $10.00 per hour will be charged per additional hour.",
  },
  {
    question: "Can I modify or cancel my reservation?",
    answer:
      "You can call us anytime to extend or return your car. Cancellations on a reserved car may forfeit the minimum $100.00 advance payment. Once a car has been paid for and picked up, we do not refund on early returns.",
  },
  {
    question: "Are there any mileage restrictions?",
    answer:
      "Commercial vehicles (utes and vans) include 150 km per day. Cars and SUVs include 200 km per day.",
  },
  {
    question: "What do I do in case of an accident?",
    answer:
      "In case of a not-at-fault accident, collect details of the at-fault party including license, name, address, insurance details, photos and claim number. Call us on 0400920512 and advise of the accident.",
  },
  {
    question: "What do I do in case of a breakdown?",
    answer:
      "Call our office on 0400920512 or text or email us. Our towing policy covers 40 km free of charge; additional km will be charged.",
  },
  {
    question: "Can I rent long term?",
    answer:
      "Long term leases and rentals can be organized at discounted rates. We consider 4 weeks or more to be long term. Please enquire with our friendly staff.",
  },
  {
    question: "Can I travel interstate?",
    answer:
      "Unfortunately, we do not allow interstate travel at this stage. We hope to relax this once we grow to have several branches.",
  },
  {
    question: "How much is the bond/deposit?",
    answer:
      "We hold a fully refundable bond of $500 for all rentals. To receive your bond back in full, please return the vehicle clean, with the same fuel level as at pickup, and without any new damage or outstanding fees.",
  },
  {
    question: "When will I receive my bond/deposit back?",
    answer:
      "In most cases, we aim to refund your bond on the same day the vehicle is returned. While this happens around 99% of the time, please allow up to 48 hours for the refund to be processed.",
  },
];
